import React, { useState } from "react";
import { SelectField } from "../../../components/common/SelectField";
import { InputField } from "../../../components/common/InputField";
import UploadedBanner from "../../../components/common/UploadBanner";
import { PlanOverviewInput } from "../../../config/allWorkout";
import { useMediaStore } from "../../../store";
import { SearchableSelectField } from "../../../components/common/SearchableSelectField";

const PlanOverView = ({
                        jsonData,
                        setUploadedJson,
                        setSelectedImageUrl,
                        setSelectedVideoUrl
                      }) => {
  const { imageUrls, videoUrls } = useMediaStore();

  const {
    plan_name,
    description,
    estimated_duration,
    level,
    banner_image,
    plan_video,
    training_type,
    workout_keywords,
  } = jsonData || {};

  // banner_image: jsonData.banner_image || imageUrl || "",
  //       plan_video: jsonData.plan_video || videoUrl || ""

  const [formData, setFormData] = useState({
    plan_name: plan_name,
    duration: estimated_duration,
    level,
    training_type: training_type,
    description,
    bannerImageUrl: banner_image,
    plan_video: plan_video,
    keywords: workout_keywords || [],
  });

  const handleSelectChange = (valueKey, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [valueKey]: value,
    }));

    setUploadedJson((prevData) => ({
      ...prevData,
      [valueKey]: value,
    }))
    // if (valueKey === "bannerImageUrl") {
    //   setSelectedImageUrl(value);
    // } else if (valueKey === "plan_video") {
    //   setSelectedVideoUrl(value);
    // }
  };

  const handleInputChange = (valueKey, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [valueKey]: value,
    }));
    setUploadedJson((prevData) => ({
      ...prevData,
      [valueKey]: value,
    }))
    if (valueKey === "bannerImageUrl") {
      setSelectedImageUrl(value);
    } else if (valueKey === "plan_video") {
      setSelectedVideoUrl(value);
    }
  };

  return (
    <div
      className="tab-pane fade show active"
      id="home-tab-pane"
      role="tabpanel"
      aria-labelledby="home-tab"
      tabIndex="0"
    >
      <div className="row">
        <div className="col-sm-6 mb-3">
          <div className="col-sm-12 mb-3">
            <h4>Plan Overview</h4>

            <div className="col-sm-12 d-flex flex-wrap">
              {PlanOverviewInput.map((fieldConfig, index) => {
                const isTextarea = fieldConfig.type === "textarea";

                return (
                  <div
                    key={index}
                    className={`me-2 flex-fill ${isTextarea ? "w-100" : ""}`}
                    style={{ minWidth: "200px" }}
                  >
                    {fieldConfig.type === "text" && (
                      <InputField
                        label={fieldConfig.label}
                        type={fieldConfig.type}
                        id={fieldConfig.id}
                        value={formData[fieldConfig.valueKey]}
                        onChange={(e) =>
                          handleInputChange(
                            fieldConfig.valueKey,
                            e.target.value
                          )
                        }
                        style={{ width: "100%" }}
                        disabled = { fieldConfig?.valueKey !== 'plan_name' }
                      />
                    )}
                    {fieldConfig.type === "select" && (
                      <SelectField
                        label={fieldConfig.label}
                        id={fieldConfig.id}
                        options={fieldConfig.options}
                        value={formData[fieldConfig.valueKey] || ""}
                        onChange={(e) =>
                          handleSelectChange(
                            fieldConfig.valueKey,
                            e.target.value
                          )
                        }
                        style={{ width: "100%" }}
                        disabled
                      />
                    )}
                    {isTextarea && (
                      <div className="mb-3">
                        <label htmlFor={fieldConfig.id} className="form-label">
                          {fieldConfig.label}
                        </label>
                        <textarea
                          className="form-control"
                          id={fieldConfig.id}
                          rows="3"
                          disabled = { fieldConfig?.valueKey !== 'description' }
                          value={formData[fieldConfig.valueKey]}
                          onChange={(e) =>
                            handleInputChange(
                              fieldConfig.valueKey,
                              e.target.value
                            )
                          }
                        />
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>


          <SearchableSelectField
            key={'img'}
            label={'Select Image Name'}
            id={'bannerImageUrl'}
            options={
              imageUrls
            }
            value={banner_image}
            onChange={(value) =>
              handleSelectChange("bannerImageUrl", value)
            }
          />

          <SearchableSelectField
            key={'video'}
            label={'Select Video Name'}
            id={'plan_video'}
            options={videoUrls}
            value={plan_video}
            onChange={(value) =>
              handleSelectChange("plan_video", value)
            }
          />

        </div>

        <div className="col-sm-6 mb-3">
          <UploadedBanner defaultImage={formData.bannerImageUrl} />
        </div>
      </div>
    </div>
  );
};

export default PlanOverView;
